import { Component, OnInit ,HostListener, ElementRef, ViewChild,Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button'
import {trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';
import { NavController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { CommonUtils } from 'src/app/services/common-utils/common-utils';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { error, log } from 'console';

@Component({
  selector: 'common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss'],
   animations: [
    trigger(
      'fixed_mobile', [
        transition(':enter', [
          style({transform: 'translateX(-100%)', opacity: 0}),
          animate('200ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('200ms', style({transform: 'translateX(-100%)', opacity: 0}))
        ])
      ]
    )
  ],
})

export class CommonHeaderComponent implements OnInit {
  @Input() count_cart: any;
  fileUrl= environment.fileUrl;
  showPopup = false;
  showToast = true;
  myColor = "rgba(255,255,255,.2)"
  mobile=false;
  hidemobile_menu;
  showmobile_menu = false;
  current_url_path_name;
  modal:any= {};
  navitems:any=[
    {icon:"account_circle",module_name:'Login',url:'/login/3'},
    {icon:"person_add",module_name:'Register',url:'/register/3'},
    {icon:"person_outline",module_name:'Partner',url:'/welcome/2'},
    {icon:"person_outline",module_name:'Seller',url:'/welcome/4'}
  ];
  // navitems start
  // navitems end
  id =2;
  sidebarItems: any=[];
  private getmenuSubscribe:Subscription;
  category;
  nav_items: any;
  username;
  changeText: string;
  userlogo;
  get_user_dtls: any;
  siteInfo = false;
  loader = false;
  model:any = {};
  razorpay_key: any;
  membership_status: any;
  rolesId: any;
  whatsappNoSubscribe: Subscription;
  hasRegistered: boolean = false;
  showPin: boolean = false;
  private getDataSubscribe: Subscription;
  disabled_close: boolean = true;
  // count_cart: any;
  constructor(
    private navCtrl : NavController,
    private router: Router,
    private authService: AuthService,
    private activatedRoute:ActivatedRoute,
    private http : HttpClient,
    private commonUtils: CommonUtils,
    private ngxLoader: NgxUiLoaderService, private httpBackend: HttpBackend) {
    //  this.getL_storage()
      this.httpWithoutInterceptor = new HttpClient(httpBackend);
    // this.getPincode();
     }

  match:any = [{name:"profile"}]
  ngAfterViewInit(){
    this.authService.globalparamsData.subscribe(res => {
      if(res != null || res != undefined){
        this.get_user_dtls = res;
        this.getsiteInfo();
        this.getUserDtls();
        this.siteInfo = true;
      }
      else{
        this.getuserInfo();
        this.siteInfo = false;
      }
    });
  }
  pincode: string | null = null;
  errorMessage: string | null = null;
  ngOnInit() {
    
    this.current_url_path_name =  this.router.url.split('/')[1];
    this.changeText="Rice"
    // this.getPincode();
  }
  
  getsiteInfo(){
    console.log("get_user_dtls",this.get_user_dtls);

    // this.ngxLoader.start();
    this.loader = true;
    setTimeout(() => {
        this.getmenuSubscribe = this.http.get('site_info').subscribe(
        (res:any) => {
          if(res.message == "Token has Expired" || res.message == "Token is Invalid"){
            this.logout();
            localStorage.removeItem('token');
            localStorage.removeItem('whatsapp_taken');

          }
          if(res.return_status > 0){
            this.loader = false;
            var username = res.return_data.username.split(" ", 1);
            this.username = res?.return_data?.business_name ? res?.return_data?.business_name : username;
            this.membership_status = res.return_data.membership_status
            this.userlogo = res.return_data.data[0];
            this.sidebarItems=res.return_data.menu;
            this.count_cart = res.return_data.count_cart;
            this.razorpay_key = res.return_data.RAZORPAY_KEY;
            this.rolesId = res.return_data.roles_id;
            this.ngxLoader.stop();
          }
          else{
            this.loader = false;
            this.ngxLoader.stop();
            if(res.return_message=="Token has Expired"){
              this.logout();
              localStorage.removeItem('token');
              localStorage.removeItem('whatsapp_taken');
            }
            this.commonUtils.presentToast('error', res.return_message); 
          }
        },
        (err) => {
          this.loader = false;
          this.ngxLoader.stop();
          this.commonUtils.presentToast('error', err.return_message); 
        }
      );
    }, 500);
       
  }
  // get menu end
  getuserInfo(){
    this.ngxLoader.start();
    setTimeout(() => {
        this.getmenuSubscribe = this.http.get('get-company-details').subscribe(
        (res:any) => {
          if(res.return_status > 0){
            this.userlogo = res.return_data[0];
            this.ngxLoader.stop();
          }else{
            this.ngxLoader.stop();
            this.commonUtils.presentToast('error', res.return_message); 
          }
        },
        (err) => {
          this.ngxLoader.stop();
          this.commonUtils.presentToast('error', err.return_message); 
        }
      );
    }, 500);
  }
  @HostListener('document:keydown', ['$event'])
  disableTab(event: KeyboardEvent) {
    if (this.showPin && event.key === 'Tab') {
      event.preventDefault(); // Disable tab key
    }
  }

  getUserDtls(){
    this.ngxLoader.start();
    this.getDataSubscribe = this.http.get("get_user_details").subscribe(
      (res:any) => {
        this.ngxLoader.stop();
        
        console.log(">>>>>>",res);
        if(res?.status == 0){
          // this.authService.logout();
        }

        this.model = res?.return_data;
        if(this.model?.pin_code == null || this.model?.pin_code == "" ||  this.model?.pin_code == "null") {
          this.showPin = true;
          this.disabled_close = true;
          this.model.pin_code = 717726;
          console.log("Pincode not found");
        }else{
          this.disabled_close = false;

        }
        this.ngxLoader.stop();
      },(error) => {
        this.ngxLoader.stop();
      });
  }
  myorder(){
    this.router.navigateByUrl('/my-orders');
  }
  subscribe(){
    this.router.navigateByUrl('/subscription');
  }
  // go to show product on search start
  onSearch(form:NgForm)
  {
    // var subId
    this.router.navigateByUrl(`search-result/${form?.value?.searchtext}`);
  }
  // go to show product on search end
  // go to home page start
  gohome(){
  }
  // go to home page end
  // go to profile page start
  options(type)
  {
    if(type == 'profile'){
      this.router.navigateByUrl('/profile');
    }
    else if(type == 'address'){
      this.router.navigateByUrl('/addresses/add/new');
    }
    else if(type == 'home')
    {
      this.router.navigateByUrl('/home');
    }
    else if(type == 'logout'){
      this.logout();
    }
  }
  // profile()
  // {
  //   this.router.navigateByUrl('/profile');
  // }
  // go to profile page end
  
  // go to login page start
  logout(){
    this.authService.logout();
    // localStorage.removeItem('token');
    // localStorage.removeItem('whatsapp_taken');
  }
  // go to login page end
  // go to cart page start
  cart()
  {
    this.router.navigateByUrl('/mycart');
  }
  // go to cart page end
  // scroll event detect
  isFixedHeader;
  onScrollHedearFix(event) {
    if (event.detail.scrollTop > 35) {
      this.isFixedHeader = true;
    } else {
      this.isFixedHeader = false;
    };
  }
  // side menu start
  togglemenu()
  {
    this.showmobile_menu = !this.showmobile_menu;
  }
  // side menu end
  //  
  addClass: boolean = false;
  // go to page on click start 

  goToPage(_url, pageurl)
  {
    if(_url == '')
    {
    }
    else
    {
      this.router.navigateByUrl(pageurl);
    }
  }
  goTosubPage(_url, _item)
  {
    this.router.navigateByUrl(_url);
  }
  userRegister(){
    this.router.navigateByUrl('register/3');
  }
  userLogin(){
    this.router.navigateByUrl('login/3');
  }
  partnerLogin(roll){
    this.router.navigateByUrl('welcome/'+roll);
  }
  sellerLogin(roll){
    this.router.navigateByUrl('welcome/'+roll);
  }
  // go to page on click end
  addCart(){
    this.router.navigateByUrl('add-cart');
  }
  openWhatsapp(){
    this.showPopup = true;
    this.showToast = false;
  }
  // isloading = false;
  addWhatsapp(form:NgForm){
    // console.log(form.value);
    this.ngxLoader.start();
    
    let data = {whatsapp_no:form.value.whatsapp_no};
    this.whatsappNoSubscribe = this.http.post('store-whatsapp',data).subscribe(
      (res:any) => {
        if(res.return_status > 0){
          localStorage.setItem('whatsapp_taken',"true");
          console.log(localStorage.getItem('whatsapp_taken'));
          this.hasRegistered = true;
          this.showPopup = false;
          this.showToast = false;
          this.ngxLoader.stop();
          this.commonUtils.presentToast('success', res.return_message); 
        }else{
          this.ngxLoader.stop();
          this.commonUtils.presentToast('error', res.return_message); 
        }
      },
      (err) => {
        this.ngxLoader.stop();
        this.commonUtils.presentToast('error', err.return_message); 
      }
    );
  }
  addPinCode(form:NgForm){
    // console.log(form.value);
    this.ngxLoader.start();
    var fd = new FormData();   
    
    fd.append("pin_code", this.model?.pincode);
    this.whatsappNoSubscribe = this.http.post('update_pincode',fd).subscribe(
      (res:any) => {
        if(res.return_status > 0){
          // localStorage.setItem('pincode',form.value.pincode);
          // console.log(localStorage.getItem('pincode'));
          this.hasRegistered = true;
          this.showPopup = false;
          this.showToast = false;
          this.ngxLoader.stop();
          this.commonUtils.presentToast('success', "Pincode Updated. Plese wait..." ); 
          setTimeout(() => {
            window.location.reload();
          }
          , 1000);
        }else{
          this.ngxLoader.stop();
          this.commonUtils.presentToast('error', res.return_message); 
        }
      },
      (err) => {
        this.ngxLoader.stop();
        this.commonUtils.presentToast('error', err.return_message); 
      }
    );
  }
  private httpWithoutInterceptor: HttpClient;
  getPincode() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const lat: number = position.coords.latitude;
          const lng: number = position.coords.longitude;

          const apiUrl: string = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;

          // Use `httpWithoutInterceptor` to avoid base URL modification
          this.httpWithoutInterceptor.get<any>(apiUrl).subscribe(
            (data) => {
              console.log("lat>>",lat,"lng>>",lng);
              
              console.log("Address>>",data?.address);
              
              console.log('Pincode:', data.address?.postcode);
              this.pincode = data.address?.postcode;
            },
            (error) => {
              console.error('Error fetching pincode:', error);
            }
          );
        },
        (error: GeolocationPositionError) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }
  getL_storage()
  {
    console.log(localStorage.getItem('whatsapp_taken'));
    if(localStorage.getItem('whatsapp_taken') == 'true'){
      this.hasRegistered = true;
    }
  }
   // ----------- destroy subscription start ---------
   ngOnDestroy() {
    if(this.getmenuSubscribe !== undefined){
      this.getmenuSubscribe.unsubscribe();
    }
  }
  // destroy subscription end
}
